import React, {FC} from 'react';

import {CompleteOrderType} from '../../../../../../../types/completeOrderType';

import {PlaceOrderErrors} from '../../../placeOrderErrors/placeOrderErrors';

import s from './amazonErrors.scss';

export type PropsType = {
    completeOrder: CompleteOrderType;
    savePaymentError: string;
};

/**
 * Amazon Pay Errors
 */
export const AmazonErrors: FC<PropsType> = React.memo(({completeOrder, savePaymentError}) => {
    const completeOrderErrors = [...((completeOrder.error && completeOrder.errors) || [])];

    return (
        <>
            {completeOrderErrors.length > 0 && <PlaceOrderErrors errors={completeOrderErrors} />}
            {savePaymentError && <span className={s.errorAmazon}>{savePaymentError}</span>}
        </>
    );
});

AmazonErrors.displayName = 'AmazonErrors';
